export const SET_OPPONENTS = 'SET_OPPONENTS';

export const setOpponents = (opponents) => ({
    type: SET_OPPONENTS, opponents
});
